import React from 'react';
import styled from 'styled-components';

// Services
import { IN_APP_PAYMENT, RECEPTION_CASH } from 'services/constants';

// Styles
const IconWrapper = styled.div`
  text-align: center;
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    width: 24px;
    height: 22px;
    &:hover {
      opacity: 0.7;
    }
  }
`;

const renderSvg = (invoice, onClick) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="22"
    viewBox="0 0 24 22"
    onClick={onClick}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0-1h24v24H0z" />
      <path
        fill={invoice && invoice.certificateNumber ? '#3ACCAC' : '#A2A4B2'}
        d="M22 0v12.5c1.2.7 2 2 2 3.5s-.8 2.8-2 3.5V22l-2-1-2 1v-2.5c-1.2-.7-2-2-2-3.5 0-2.2 1.8-4 4-4V6c-2.2 0-4-1.8-4-4H6c0 2.2-1.8 4-4 4v8c2.2 0 4 1.8 4 4h8v2H0V0h22zM6 9v2h10V9H6zm2 4v2h6v-2H8zm0-8v2h6V5H8zm12 9c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
      />
    </g>
  </svg>
);

export default props => {
  const { invoice, onClick } = props;

  if (invoice) {
    return <IconWrapper>{renderSvg(invoice, onClick)}</IconWrapper>;
  } else {
    return renderSvg();
  }
};
